var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
// SPDX-FileCopyrightText: 2023, 2024 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useMemo } from "react";
import { DatagridConfigurable, FunctionField, List, TextField } from "react-admin";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import SelectElection from "@/components/election/SelectElection";
import { COUNTRIES } from "@/lib/countries";
import { FormStyles } from "@/components/styles/FormStyles";
import { ListActions } from "@/components/ListActions";
var ListStyle = styled(List)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    button.RaFilterFormInput-hideButton {\n        margin-bottom: 26px !important;\n    }\n"], ["\n    button.RaFilterFormInput-hideButton {\n        margin-bottom: 26px !important;\n    }\n"])));
export var ListIpAddress = function (_a) {
    var aside = _a.aside, electionEventId = _a.electionEventId, electionId = _a.electionId;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var Filters = useMemo(function () { return [
        _jsx(FormStyles.TextInput, { source: "ip", label: "".concat(t("dashboard.ipAddress.ip")) }, "ip"),
        _jsx(FormStyles.AutocompleteInput, { source: "country", label: "".concat(t("dashboard.ipAddress.country")), choices: COUNTRIES, optionValue: "code", fullWidth: true }, "country"),
        _jsx(SelectElection, { source: "election_id", label: "".concat(t("dashboard.ipAddress.ElectionName")), tenantId: tenantId, electionEventId: electionEventId }, "election"),
    ]; }, []);
    var Empty = function () { return (_jsx(ResourceListStyles.EmptyBox, __assign({ style: { margin: "8px" } }, { children: _jsx(Typography, __assign({ variant: "h4", paragraph: true }, { children: t("dashboard.ipAddress.emptyState") })) }))); };
    var filters = function () {
        var filters = {
            tenant_id: tenantId,
        };
        if (electionEventId) {
            filters["election_event_id"] = electionEventId;
        }
        if (electionId) {
            filters["election_id"] = electionId;
        }
        return filters;
    };
    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "h4" }, { children: t("dashboard.ipAddress.title") })), _jsx(ListStyle, __assign({ resource: "ip_address", queryOptions: {
                    refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
                }, empty: _jsx(Empty, {}), filter: filters(), storeKey: false, aside: aside, filters: Filters, actions: _jsx(ListActions, { withImport: false, defaultExport: true }) }, { children: _jsxs(DatagridConfigurable, __assign({ omit: ["voters_id"] }, { children: [_jsx(FunctionField, { source: "ip", sortable: false, label: "".concat(t("dashboard.ipAddress.ip")), render: function (record) { return (record.ip ? record.ip : "-"); } }), _jsx(FunctionField, { source: "country", sortable: false, label: "".concat(t("dashboard.ipAddress.country")), render: function (record) { return (record.ip ? record.ip : "-"); } }), _jsx(TextField, { source: "vote_count", sortable: false, label: "".concat(t("dashboard.ipAddress.VoteCount")) }), _jsx(TextField, { source: "election_name", sortable: false, label: "".concat(t("dashboard.ipAddress.ElectionName")) }), _jsx(TextField, { source: "voters_id", sortable: false, label: "".concat(t("dashboard.ipAddress.VotersId")) })] })) }))] }));
};
var templateObject_1;
